import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import MfproductorderPageImpl from './MfproductorderPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';
import { setMfproductorderDashboardMfproductorderList,setSelectedMforderId,
    setMforderDashboardMforderList, setTaskinstanceList
 } from 'store/slice/ManufSlice';
import { getMfproductorderInfoByStatusidAPI } from '../MfproductorderAPI';
import { getListAPI } from 'components/taskinstance/TaskinstanceAPI';

export default function MfproductorderPage() {
    const dispatch = useDispatch();
    const {mfproductorderList} = useSelector((state)=>state.manufslice);
    const {mforderList} = useSelector((state)=>state.manufslice);

    useEffect(() => {
        dispatch(openDrawer({drawerOpen:false}));
        dispatch(setSelectedMforderId(-1));

        dispatch(setMforderDashboardMforderList(
            mforderList.filter(mfOrder=>mfOrder.orderstatusid===6)
        ))
        getListAPI(()=>{}, getTaskInstanceListSuccess);
    },[]);

    const getTaskInstanceListSuccess = (apiResponse) =>{
        dispatch(setTaskinstanceList(apiResponse))
    }

    const getProductOrderWithWIPstatusSuccess = (apiResponse) =>{
        const uniqueProducts = apiResponse.reduce((acc, curr) => {
            if (!acc.some(item => item.productid === curr.productid)) {
              acc.push(curr);
            }
            return acc;
          }, []);

          dispatch(setMfproductorderDashboardMfproductorderList(uniqueProducts))
        
    }

    return (
        <MfproductorderPageImpl />
    )
}